import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import FloatingSkills from "../../components/floatingSkills/FloatingSkills";
import { Fade } from "react-reveal";
import { skills } from "../../portfolio.js";

export default function Skills(props) {
  const theme = props.theme;
  return (
    <div className="main" id="skills">
      <div className="skills-header-div" style={{ position: "relative" }}>
        <FloatingSkills skills={skills} theme={theme} />
        <Fade bottom duration={2000} distance="20px">
          <h1 className="skills-header" style={{ color: theme.text }}>
            Here's what I do
          </h1>
        </Fade>
      </div>
      <SkillSection theme={theme} />
    </div>
  );
}
